import { render, staticRenderFns } from "./redact.vue?vue&type=template&id=d59d41be&scoped=true"
import script from "./redact.vue?vue&type=script&lang=ts&setup=true"
export * from "./redact.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59d41be",
  null
  
)

export default component.exports